// extracted by mini-css-extract-plugin
export default {"page":"yJcSK09OIgAz0kfw9Pov","tablelink":"oaYhPE7zxoOe9TYylKY0"};